import moment from 'moment';

import messages from '../locale/messages';

import pMath from "./pMath";
import { convert } from "./currencyConvertion";
import { daysCountWithoutWeekends } from "./pleXpad";

export default {
  standardBooking(bookingData) {
    const { basePrice, promoPrice, cleaningPrice, currency, monthlyDiscount, weeklyDiscount, startDate, endDate } = bookingData;
    const { serviceFees, base, rates, specialPricing, taxRate } = bookingData;
    const { isHotDesking, isOpenOnWeekends, freeTrialDays, guests, useFreeTrial } = bookingData;
    const { projectTicketmaster } = bookingData;
    const { formatMessage } = bookingData;

    let guestServiceFee = 0, hostServiceFee = 0, hostServiceFeeType = '', hostServiceFeeValue = 0;
    let currentDay, bookingPricing = [], isSpecialPriceAssigned = false;
    let priceForDays = 0, averageDayRate = 0;

    let freeTrialDaysRemaining = useFreeTrial ? freeTrialDays : 0;
    let freeTrialDaysCount = 0;

    let promoDays = 0;

    let momentStartDate, momentEndDate, stayLength, stayLengthBillable = 0, discount = 0, discountType, subTotal = 0, taxAmount = 0, total = 0, totalLessServiceFee = 0, subTotalLessDiscount = 0;
    if (startDate != null && endDate != null) {
      momentStartDate = moment(startDate);
      momentEndDate = moment(endDate);
      stayLength = momentEndDate.diff(momentStartDate, 'days')+1;
      stayLengthBillable = isOpenOnWeekends == true ? stayLength : daysCountWithoutWeekends(momentStartDate.toDate(), momentEndDate.toDate());
      promoDays = promoPrice ? Math.min(5, stayLengthBillable) : 0;

      if (stayLength > 0) {
        let stayedDays = [];
        // Find stayed nights
        for (let i = 0; i < stayLength; i++) {
          let currentDate = moment(startDate).add(i, 'day');
          if( isOpenOnWeekends == true || currentDate.toDate().getDay() != 0 && currentDate.toDate().getDay() != 6 ) stayedDays.push(currentDate);
        }

        if (stayedDays && stayedDays.length > 0) {
          stayedDays.map((item, key) => {
            try {
              let isSpecialPricing, pricingRow, currentPrice;
              /* currentDay = (moment(item).format('dddd').toLowerCase()); */
              if( freeTrialDaysRemaining ) {
                currentPrice = 0;
                ++freeTrialDaysCount;
                --freeTrialDaysRemaining;
                --stayLengthBillable;
              }
              else {
                isSpecialPricing = false;//specialPricing.find(o => moment(item).format('MM/DD/YYYY') == moment(o.blockedDates).format('MM/DD/YYYY'));
                if (isSpecialPricing && isSpecialPricing.isSpecialPrice) {
                  isSpecialPriceAssigned = true;
                  currentPrice = Number(isSpecialPricing.isSpecialPrice);
                } else {
                  currentPrice = promoPrice && key < 5 ? Number(promoPrice) : Number(basePrice);
                  if( promoPrice && key < 5 ) {
                    //++promoDays;
                    return item;
                  }
                }
              }
              // Price object
              pricingRow = {
                blockedDates: item,
                dayPrice: currentPrice,
              };
              bookingPricing.push(pricingRow);
            }
            catch( error ) {
              console.error('Error in map callback:', error);
            }
          });
        }
      }

      bookingPricing.map((item, index) => {
        priceForDays += Number(item.dayPrice);
      });
    }

    averageDayRate = (stayLengthBillable - promoDays) > 0 ? Number(priceForDays) / Number(stayLengthBillable - promoDays) : 0;
    //priceForDays = pMath.round(averageDayRate, 2) * stayLengthBillable;
    if( promoPrice ) priceForDays += Number(promoPrice * promoDays);
    if( isHotDesking ) priceForDays *= guests;

    if (stayLengthBillable >= (isOpenOnWeekends == true ? 7 : 5)) {
      if (monthlyDiscount > 0 && stayLengthBillable >= (isOpenOnWeekends == true ? 28 : 21)) {
        discount = (Number(priceForDays) * Number(monthlyDiscount)) / 100;
        discountType = monthlyDiscount + "% " + formatMessage(messages.monthlyDiscount);
      } else if( weeklyDiscount > 0 ) {
        discount = (Number(priceForDays) * Number(weeklyDiscount)) / 100;
        discountType = weeklyDiscount + "% " + formatMessage(messages.weeklyDiscount);
      }
    }
    subTotalLessDiscount = priceForDays - discount;
    totalLessServiceFee = (priceForDays + cleaningPrice) - discount;

    if( projectTicketmaster ) {
      hostServiceFeeType = 'percentage';
      hostServiceFeeValue = 0.04;
      hostServiceFee = pMath.round(totalLessServiceFee * hostServiceFeeValue);
    }
    else if (serviceFees) {
      if (serviceFees.guest.type === 'percentage') {
        guestServiceFee = totalLessServiceFee * (Number(serviceFees.guest.value) / 100);
      } else {
        guestServiceFee = convert(base, rates, serviceFees.guest.value, serviceFees.guest.currency, currency);
      }

      if (serviceFees.host.type === 'percentage') {
        hostServiceFeeType = serviceFees.host.type;
        hostServiceFeeValue = serviceFees.host.value;
        hostServiceFee = totalLessServiceFee * (Number(serviceFees.host.value) / 100);
      } else {
        hostServiceFeeType = serviceFees.host.type;
        hostServiceFeeValue = serviceFees.host.value;
        hostServiceFee = convert(base, rates, serviceFees.host.value, serviceFees.host.currency, currency);
      }
      guestServiceFee = pMath.round(guestServiceFee, 2);
      hostServiceFee = pMath.round(hostServiceFee, 2);
    }

    subTotal = (priceForDays + guestServiceFee + cleaningPrice) - discount;

    if( taxRate ) {
      taxAmount = pMath.round(subTotal * taxRate / 100, 2);
    }

    total = taxAmount ? pMath.round(subTotal + taxAmount, 2) : subTotal;

    return {
      freeTrialDaysCount,
      stayLengthBillable,
      isSpecialPriceAssigned,
      promoDays,
      averageDayRate,
      priceForDays,
      discount,
      discountType,
      subTotalLessDiscount,
      totalLessServiceFee,
      guestServiceFee,
      hostServiceFee,
      subTotal,
      taxAmount,
      total
    }
  },

  monthlyPass(bookingData) {
    const { basePrice, isOpenOnWeekends, monthlyPass, monthlyPassPrice, monthlyPassPromoPrice, isHotDesking, guests, taxRate } = bookingData;

    let monthlyPassSavings = 0;
    let monthlyPassSubTotal = 0;
    let monthlyPassPromoSubTotal = 0;
    let monthlyPassTaxAmount = 0;
    let monthlyPassTotal = 0;

    let monthlyPriceAtDayRate = basePrice * (isOpenOnWeekends ? 30.4 : 21.6);
    if( monthlyPriceAtDayRate > (monthlyPassPromoPrice ? monthlyPassPromoPrice : monthlyPassPrice) ) {
      monthlyPassSavings = pMath.round(monthlyPriceAtDayRate - (monthlyPassPromoPrice ? monthlyPassPromoPrice : monthlyPassPrice));
    }
    if( monthlyPass ) {
      monthlyPassSubTotal = isHotDesking ? pMath.round(monthlyPassPrice * guests) : monthlyPassPrice;
      if( monthlyPassPromoPrice ) monthlyPassPromoSubTotal = isHotDesking ? pMath.round(monthlyPassPromoPrice * guests) : monthlyPassPromoPrice;
      
      if( taxRate ) {
        monthlyPassTaxAmount = pMath.round(monthlyPassSubTotal * taxRate / 100);
        if( monthlyPassPromoPrice ) monthlyPassTaxAmount = pMath.round(monthlyPassPromoSubTotal * taxRate / 100);
      }

      monthlyPassTotal = pMath.round(monthlyPassSubTotal + monthlyPassTaxAmount);
      if( monthlyPassPromoPrice ) monthlyPassTotal = pMath.round(monthlyPassPromoSubTotal + monthlyPassTaxAmount);
    }

    return {
      monthlyPassSavings,
      monthlyPassSubTotal,
      monthlyPassPromoSubTotal,
      monthlyPassTaxAmount,
      monthlyPassTotal
    }
  },

  monthPass(bookingData) {
    const { basePrice, isOpenOnWeekends, monthPass, monthPassPrice, isHotDesking, guests, taxRate } = bookingData;

    let monthPassSavings = 0;
    let monthPassSubTotal = 0;
    let monthPassTaxAmount = 0;
    let monthPassTotal = 0;

    let monthPriceAtDayRate = basePrice * (isOpenOnWeekends ? 30.4 : 21.6);
    if( monthPriceAtDayRate > monthPassPrice ) {
      monthPassSavings = pMath.round(monthPriceAtDayRate - monthPassPrice);
    }
    if( monthPass ) {
      monthPassSubTotal = isHotDesking ? pMath.round(monthPassPrice * guests) : monthPassPrice;
      
      if( taxRate ) {
        monthPassTaxAmount = pMath.round(monthPassSubTotal * taxRate / 100);
      }

      monthPassTotal = pMath.round(monthPassSubTotal + monthPassTaxAmount);
    }

    return {
      monthPassSavings,
      monthPassSubTotal,
      monthPassTaxAmount,
      monthPassTotal
    }
  }
}


// WEBPACK FOOTER //
// src/helpers/bookingCalculations.js